/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { gameGetGameMinecraftServerstatus } from "../../funcs/gameGetGameMinecraftServerstatus.js";
import { GetGameMinecraftServerstatusRequest$zodSchema } from "../../models/getgameminecraftserverstatusop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetGameMinecraftServerstatusRequest$zodSchema,
};

export const tool$gameGetGameMinecraftServerstatus: ToolDefinition<
  typeof args
> = {
  name: "game-get-game-minecraft-serverstatus",
  description: `查询 MC 服务器

想在加入服务器前看看有多少人在线？或者检查一下服务器开没开？用这个接口就对了！

## 功能概述
你可以通过提供服务器地址（域名或IP），来获取一个 Minecraft Java 版服务器的实时状态。返回信息非常丰富，包括服务器是否在线、当前玩家数、最大玩家数、服务器版本、MOTD（每日消息）以及服务器图标等。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await gameGetGameMinecraftServerstatus(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
